import { StateUtils } from '@spartacus/core';
import { PAGE, SeoPageState } from '../seo-state';

export const LOAD_PAGE = '[Seo] Page Load';
export const LOAD_PAGE_SUCCESS = '[Seo] Page Load Success';
export const LOAD_PAGE_FAIL = '[Seo] Page Load Fail';

export class PageLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PAGE;

  constructor(public payload: { urlOrLabel: string; baseStoreCode: string }) {
    super(PAGE);
  }
}

export class PageLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PAGE_FAIL;

  constructor(public payload: any) {
    super(PAGE, payload);
  }
}

export class PageLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PAGE_SUCCESS;

  constructor(public payload: SeoPageState | null) {
    super(PAGE);
  }
}

export type PageLoadAction = PageLoad | PageLoadFail | PageLoadSuccess;
